// Адаптивный вариант со вторичной очередью и интернационализацией
function ChatInvitationsModule(options) {
    var INV_TYPE_ONLINE = 'no';
    var INV_TYPE_INV = 'yes';
    var INV_TYPE_BCAST = 'bcast';
    var INV_TYPE_VIEW = 'viewer';
    var INV_TYPE_STREAM = 'stream';

    var langs = {
        'en': {
            chat_btn: 'Start Chat',
            chat_btn_video: 'Start Video Chat',
            chat_btn_free: 'Start FREE Chat!',
            chat_btn_stream: 'Watch Stream',
            tictactoe: "Tic-tac-toe",
            billiards: "Billiards",
            online_users: 'Online users',
            no_inv_at_the_moment: 'No invitations at the moment',
            new_invites_1: '1 user invites you to chat!',
            new_invites: '{count} users invite you to chat!',
            game_invite: ({name, game}) => `${name} invites you to play ${game}!`,
            viewer_message: ({name, age}) => `Is watching your profile now`,
            is_online_message: ({name, age}) => `<strong>${name}, ${age}</strong> is online`,
            close: 'Close',
            new_inv_title_blink: "*** New chat invitation!!! ***",
            new_inv_title_blink1: 'Attention!'
        },
        'nl': {
            chat_btn: 'Start Chat <span class="notifier-startchat-button__now">Nu</span>!',
            "chat_btn_video": "Videogesprek starten",
            chat_btn_free: 'Start GRATIS chatten!',
            chat_btn_stream: 'Stream bekijken',
            tictactoe: "Tic-tac-toe",
            billiards: "Biljart",
            online_users: 'Online gebruikers',
            no_inv_at_the_moment: 'Geen uitnodigingen op dit moment',
            new_invites_1: '1 gebruiker nodigt u uit om te chatten!',
            new_invites: '{count} gebruikers nodigen je uit om te chatten!',
            game_invite: ({name, game}) => `${name} nodigt u uit om ${game} te spelen!`,
            viewer_message: ({name, age}) => `Kijkt nu naar uw profiel`,
            is_online_message: ({name, age}) => `<strong>${name}, ${age}</strong> is online`,
            close: 'Sluiten',
            new_inv_title_blink: "*** Nieuwe chatuitnodiging!!! ***",
            new_inv_title_blink1: 'Opgelet!'
        },
        'es': {
            "chat_btn": "Iniciar Chat",
            "chat_btn_video": "Iniciar Videochat",
            chat_btn_free: 'Empezar chat GRATIS',
            chat_btn_stream: 'Ver la transmisión',
            tictactoe: "3 en raya",
            billiards: "Billar",
            online_users: 'Usuarias conectadas',
            no_inv_at_the_moment: 'No tiene invitaciones por el momento',
            new_invites_1: '¡1 usuario le invita a chatear!',
            new_invites: '¡{count} usuarios le invitan a chatear!',
            game_invite: ({name, game}) => `¡${name} le invita a jugar ${game}!`,
            viewer_message: ({name, age}) => `Está viendo su perfil ahora`,
            is_online_message: ({name, age}) => `<strong>${name}, ${age}</strong> está en línea`,
            close: 'Cerrar',
            new_inv_title_blink: "*** ¡¡Nuevas invitaciones a chatear!! ***",
            new_inv_title_blink1: '¡Atención!'
        },
        'sv': {
            "chat_btn": "Starta chatt",
            "chat_btn_video": "Starta videochatt",
            chat_btn_free: 'Starta chatten GRATIS',
            chat_btn_stream: 'Titta på livestreamen',
            tictactoe: "Luffarschack",
            billiards: "Biljard",
            online_users: 'Användare online',
            no_inv_at_the_moment: 'Inga inbjudningar för tillfället',
            new_invites_1: '1 användare bjuder in dig till chatt!',
            new_invites: '{count} användare bjuder in dig till chatt!',
            game_invite: ({name, game}) => `${name} bjuder in dig att spela ${game}!`,
            viewer_message: ({name, age}) => `Tittar på din profil nu`,
            is_online_message: ({name, age}) => `<strong>${name}, ${age}</strong> är online`,
            close: 'Stäng',
            new_inv_title_blink: "*** Ny chatt-inbjudan!!! ***",
            new_inv_title_blink1: 'Var uppmärksam!'
        },
        'fr': {
            chat_btn: "Démarrer le chat",
            "chat_btn_video": "Démarrer le chat vidéo",
            chat_btn_free: 'Chat gratuit!',
            chat_btn_stream: 'Regarder le stream',
            tictactoe: "Tic-tac-toe",
            billiards: "Billard",
            online_users: 'Utilisateurs en ligne',
            no_inv_at_the_moment: 'Aucune invitation pour le moment',
            new_invites_1: 'Un utilisateur vous invite à discuter!',
            new_invites: '{count} utilisateurs vous invitent à discuter!',
            game_invite: ({name, game}) => `${name} vous invite à jouer à ${game}!`,
            viewer_message: ({name, age}) => `Surveille votre profil en ce moment`,
            is_online_message: ({name, age}) => `<strong>${name}, ${age}</strong> est en ligne`,
            close: 'Fermer',
            new_inv_title_blink: "*** Nouvelle invitation à discuter !!! ***",
            new_inv_title_blink1: 'Attention!'
        },
        'ja': {
            chat_btn: 'チャットを開始する',
            "chat_btn_video": "ビデオチャットを開始",
            chat_btn_free: '無料チャット',
            chat_btn_stream: 'ストリーミングを視聴する',
            tictactoe: "まるばつゲーム",
            billiards: "ビリヤード",
            online_users: 'ユーザーがオンラインです',
            no_inv_at_the_moment: '現在招待状はありません',
            new_invites_1: '1人の女性がチャットに招待しています！',
            new_invites: '{count} 人の女性があなたをチャットに招待しています！',
            game_invite: ({name, game}) => `${name} さんがあなたと ${game} をプレイするのに招待しています!`,
            viewer_message: ({name, age}) => `が現在あなたのプロフィールを閲覧しています`,
            is_online_message: ({name, age}) => `<strong>${name}, ${age}</strong> がオンラインです`,
            close: '閉じる',
            new_inv_title_blink: "*** 新しいチャットの招待状です!!! ***",
            new_inv_title_blink1: 'ご覧ください!'
        },
        'de': {
            chat_btn: 'Chat starten',
            "chat_btn_video": "Video-Chat starten",
            chat_btn_free: 'Gratis-Chat starten',
            chat_btn_stream: 'Stream sich ansehen',
            tictactoe: "Tic-tac-toe",
            billiards: "Billard",
            online_users: 'Benutzer online',
            no_inv_at_the_moment: 'Zur Zeit keine Einladungen',
            new_invites_1: '1 Benutzer lädt Sie zum Chatten ein!',
            new_invites: '{count} Benutzer laden zum Chatten ein!',
            game_invite: ({name, game}) => `${name} lädt Sie zum Spielen ein ${game}!`,
            viewer_message: ({name, age}) => `Beobachtet gerade Ihr Profil`,
            is_online_message: ({name, age}) => `<strong>${name}, ${age}</strong> ist online`,
            close: 'Schließen',
            new_inv_title_blink: "*** Neue Chat-Einladung!!! ***",
            new_inv_title_blink1: 'Aufgepasst!'
        },
        'pt': {
            "chat_btn": "Iniciar Chat",
            "chat_btn_video": "Iniciar Videochat",
            "chat_btn_free": "Iniciar Chat GRÁTIS!",
            "chat_btn_stream": "Ver transmissão",
            "tictactoe": "Jogo do Galo",
            "billiards": "Bilhar",
            "online_users": "Utilizadores online",
            "no_inv_at_the_moment": "Sem convites de momento",
            "new_invites_1": "1 utilizador convida-te para conversar!",
            "new_invites": "{count} utilizadores convidam-te para conversar!",
            "game_invite": ({name, game}) => `${name} convida-te para jogar ${game}!`,
            "viewer_message": ({name, age}) => `Está a ver o teu perfil agora`,
            "is_online_message": ({name, age}) => `<strong>${name}, ${age}</strong> está online`,
            "close": "Fechar",
            "new_inv_title_blink": "*** Novo convite para o chat!!! ***",
            "new_inv_title_blink1": "Atenção!"
        },
        'da': {
            chat_btn: 'Start chat',
            "chat_btn_video": "Start Videochat",
            chat_btn_free: 'Start GRATIS chat!',
            chat_btn_stream: 'Se stream',
            tictactoe: "Trek på stribe",
            billiards: "Billard",
            online_users: 'Online brugere',
            no_inv_at_the_moment: 'Ingen invitationer i øjeblikket',
            new_invites_1: '1 bruger inviterer dig til at chatte!',
            new_invites: '{count} brugere inviterer dig til at chatte!',
            game_invite: ({name, game}) => `${name} inviterer dig til at spille ${game}!`,
            viewer_message: ({name, age}) => `Ser på din profil nu`,
            is_online_message: ({name, age}) => `<strong>${name}, ${age}</strong> er online`,
            close: 'Luk',
            new_inv_title_blink: "*** Ny chatinvitation!!! ***",
            new_inv_title_blink1: 'Opmærksomhed!'
        },
        'ar': {
            "chat_btn": "ابدأ الدردشة",
            "chat_btn_video": "بدء دردشة الفيديو",
            "chat_btn_free": "ابدأ الدردشة المجانية!",
            "chat_btn_stream": "مشاهدة البث",
            "tictactoe": "إكس-أو",
            "billiards": "البلياردو",
            "online_users": "المستخدمون المتصلون",
            "no_inv_at_the_moment": "لا توجد دعوات حالياً",
            "new_invites_1": "مستخدم واحد يدعوك للدردشة!",
            "new_invites": "{count} مستخدمين يدعونك للدردشة!",
            "game_invite": ({name, game}) => `‏${name} يدعوك للعب ${game}!`,
            "viewer_message": ({name, age}) => `يشاهد ملفك الآن`,
            "is_online_message": ({name, age}) => `<strong>${name}، ${age} سنة</strong> متصل الآن`,
            "close": "إغلاق",
            "new_inv_title_blink": "*** دعوة دردشة جديدة!!! ***",
            "new_inv_title_blink1": "انتباه!"
        }
    }
    var lang_code = document.documentElement.lang;
    if(!(lang_code in langs)) {
        lang_code = 'en';
    }
    var _l = langs[lang_code];
    var self = this;
    var INSTANCE_ID;
    INSTANCE_ID = Math.ceil(Math.random() * 65535);

    if (typeof options === 'undefined') options = {};

    var storage_supported = 'localStorage' in window;
    var animations_enabled = true;
    var horizontal_enabled = false;
    var mobile_enabled = false;
    var laptop_enabled = false;

    // Сколько приглашение живёт во второй очереди
    var after_expired_timeout_sec = 180;
    var $ = window.jQuery;

    var defaults = {
        logged_in: false,
        profile_link_template: '',
        streaming_link_template: '/streaming.php?id=%real_id%',
        login_link_template: '/login.php?reg_via=ci_popup&gID=%id%&redirect=%redirect%',
        polling_interval: mobile_enabled ? 8000 : 5000,
        custom_open_chat_action: null,
        style: 'default',
        scripts_root: '/',
        demo: false,
        demo_invitations: null,
    };
    options = Object.assign({}, defaults, options);

    if(options.demo) {
        storage_supported = false;
    }

    var assessMedia = function() {
        laptop_enabled = window.matchMedia('(min-width: 992px) and (max-width: 1900px)').matches;
        horizontal_enabled = window.matchMedia('(min-width: 560px) and (max-width: 991px)').matches;
        mobile_enabled = window.matchMedia('(max-width: 559px)').matches;
        if(options.style === 'in_chat') {
            horizontal_enabled = false;
            mobile_enabled = false;
        }
    };
    assessMedia();
    window.addEventListener('resize', assessMedia);

    var default_storage = {
        queue: [],
        last_event: null,
        last_updated: 0,
        host: null,
        qid: 0,
        collapse_state: 1
    };
    var STORAGE = default_storage;
    var STORAGE_KEY = 'chat_invites';
    var queue_loaded = false;

    var loadStorage = function () {
        if (!storage_supported) {
            return;
        }
        var out = localStorage.getItem(STORAGE_KEY);
        STORAGE = out ? JSON.parse(out) : null;
    };
    var saveStorage = function () {
        if (!storage_supported) {
            return;
        }
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(STORAGE));
        } catch (e) {
            localStorage.clear();
            localStorage.setItem(STORAGE_KEY, JSON.stringify(STORAGE));
        }
    };
    var initStorage = function () {
        if (!storage_supported) {
            return;
        }
        loadStorage();
        if (STORAGE === null) {
            STORAGE = default_storage;
            saveStorage();
        }
    };

    var escapeHtml = function (str) {
        var r = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;'
        };
        return str.replace(/[&<>]/g, function(entity) {
            return r[entity] || entity;
        });
    };
    var becomeHost = function () {
        STORAGE.last_updated = (new Date).getTime();
        STORAGE.host = INSTANCE_ID;
        STORAGE.qid = 0;
        saveStorage();
    };

    var profile_link = function (id) {
        let l = options.profile_link_template.replace('%id%', id).replace('%real_id%', id );
        let i = 'inv_v'; // vertical;
        if(horizontal_enabled) {
            i = 'inv_h'; // horizontal;
            if(mobile_enabled) {
                i = 'inv_hfw'; // horizontal_full_w;
            }
        }
        if(laptop_enabled) {
            i = 'inv_lv';
        }
        if(l.indexOf('?') >= 0) {
            l += '&bh_medium=' + i;
        } else {
            l += '?bh_medium=' + i;
        }
        return l;
    };

    var streaming_link = function (id) {
        return options.streaming_link_template.replace('%real_id%', id );
    };

    var slideToggle = function (el) {
        if (!el) {
            return;
        }
        el.style.height === '0px' ? slideDown(el) : slideUp(el);
    };

    var slideUp = function (el) {
        var wrapper2 = self.chatCreateSecondaryContainer();

        var adjust_parameter = horizontal_enabled && !wrapper2.contains(el) ? 'width' : 'height';
        var adjust_measurement = horizontal_enabled && !wrapper2.contains(el) ? 'scrollWidth' : 'scrollHeight';

        if (!el || el.style[adjust_parameter] === '0px') {
            return;
        }
        el.classList.add('--slide-up');
        el.style[adjust_parameter] = el[adjust_measurement] + 'px';
        setTimeout(function () {
            el.style[adjust_parameter] = '0px';
        }, 10);
    };

    var slideDown = function (el, callback) {
        var adjust_parameter = horizontal_enabled ? 'width' : 'height';
        var adjust_measurement = horizontal_enabled ? 'scrollWidth' : 'scrollHeight';

        if (!el || el.style[adjust_parameter] !== '0px') {
            return;
        }
        el.style[adjust_parameter] = el[adjust_measurement] + 'px';
        if (animations_enabled && 'transition' in document.body.style) {
            var fn = function () {
                el.style[adjust_parameter] = 'auto';
                this.removeEventListener('transitionend', fn);
                if (callback) {
                    callback();
                }
            };
            el.addEventListener('transitionend', fn);
        } else {
            el.style[adjust_parameter] = 'auto';
            if (callback) {
                callback();
            }
        }
    };

    var fadeOut = function (el) {
        if (!el) {
            return;
        }
        el.style.opacity = 0;
    };

    var fadeIn = function (el) {
        if (!el) {
            return;
        }
        el.style.opacity = 1;
    };

    var isInv;
    var stateOfNotifiers = 1;
    var text_online = "";
    var timBlinkTimer = null; //таймер мигания
    var strOldTitle = document.title;

    var arCounters = {};
    var arAfterTimeouts = {};
    var arInvUpdate = {};
    var arChatButtonNames = {
        normal: _l.chat_btn, bonus: _l.chat_btn_free, stream: _l.chat_btn_stream, video: _l.chat_btn_video
    };

    var arChatGames = {
        'tictactoe': _l.tictactoe, 'tictactoe_v2': _l.tictactoe, 'pool': _l.billiards
    };

    var getElementSizes = function (element) {
        var width = element.offsetWidth;
        var height = element.offsetHeight;
        return {
            "width": width, "height": height
        };
    }

    // удаление элемента DOM
    var removeElement = function (element) {
        jQuery(element).empty().remove();
    }

    var getClientWidth = function () {
        return document.compatMode == 'CSS1Compat' && !window.opera ? document.documentElement.clientWidth : document.body.clientWidth;
    }

    var getClientHeight = function () {
        return document.compatMode == 'CSS1Compat' && !window.opera ? document.documentElement.clientHeight : document.body.clientHeight;
    }

    //прокрутка сообщения
    var messageScroll = function (el, options) {
        if (!el) {
            return;
        }

        var obj = jQuery(el);
        var text = obj.find('.notifier-message-text-content');
        var heightObj = obj.height();
        var heightText = text.height();
        var id = el.id;

        if(!animations_enabled) {
            el.style.overflow = 'auto';
            return;
        }

        var rollIt = function (parentHeight) {
            var obj = jQuery('#' + id + ' .notifier-message-text-content');
            if (obj.length == 0)
                return;
            var height = obj.height();
            var basetime = height / 14 * 750;
            var totaltime = Math.ceil(basetime * (options.speed / 100));
            var target = -height;
            var targetTop = target + parentHeight * 0.75;

            var fn = function () {
                var self = this;
                setTimeout(function () {
                    self.style.transition = 'none';
                    self.style.transform = 'translateY(0)';
                    setTimeout(function () {
                        self.style.transition = 'transform ' + (totaltime / 1000).toFixed(2) + 's linear';
                        self.style.transform = 'translateY(' + (targetTop).toFixed(2) + 'px)';
                    }, options.delayEnd);
                }, options.delayEnd);
            };

            obj[0].addEventListener('transitionend', fn);

            if ('transition' in document.body.style) {
                setTimeout(fn.apply(obj[0]), options.delayEnd);
            }
        };

        if (heightText > heightObj) {
            rollIt(heightObj);
        }
    };

    this.chatCreateMainContainer = function () {
        var mainContainer = document.getElementById("chat_main_container");

        if (mainContainer != null) {
            // если контейнер уже существует, то просто возвращаем ссылку на него
            return mainContainer;
        } else {
            let wrapper = document.createElement('div');
            wrapper.className = "chat-popup-container-wrapper";
            document.body.appendChild(wrapper);
            // создаем элемент Div, который будет служить основным контейнером для всех остальных элементов
            var newDiv = document.createElement("div");
            wrapper.appendChild(newDiv);

            newDiv.id = "chat_main_container";

            // ширина основного контейнера
            var containerWidth = 255, title;
            newDiv.style.display = 'none';
            newDiv.className = "chat-popup-container chat-popup-container--" + options.style;
            if(animations_enabled) {
                newDiv.style.transition = "opacity 0.7s ease-out, transform 0.7s ease-out, box-shadow 0.7s ease-out";
            }

            // определяем первоначальный блок для функций Minimize и Maximize
            if (isInv == INV_TYPE_INV || isInv == INV_TYPE_BCAST) {
                title = `<div class='chat-popup-container-title'>${_l.online_users}</div>`;
            } else {
                title = `<div class='chat-popup-container-title'>${_l.online_users}</div>`;
            }
            newDiv.innerHTML = '<div class="chat-popup-container-title-wrapper"><div class="minimizer" id="r_block"></div><div class="chat-popup__online-icon"></div>' + title + '</div>';

            // это общий суб-контейнер для блоков-элементов с приглашениями к чату
            if(animations_enabled) {
                newDiv.innerHTML += '<div id="visual_elements_wrapper" class="notifiers-viewport" style="transition: height 0.7s ease-out, opacity 0.7s ease-out"><div id="visual_elements" class="notifiers-wrapper"></div></div>';
            } else {
                newDiv.innerHTML += '<div id="visual_elements_wrapper" class="notifiers-viewport"><div id="visual_elements" class="notifiers-wrapper"></div></div>';
            }

            newDiv.querySelector('.chat-popup-container-title').addEventListener('click', self.chatMiniMaxi);
            newDiv.querySelector('#r_block').addEventListener('click', self.chatMiniMaxi);

            SpecialOfferTimer();
            if(laptop_enabled && STORAGE.collapse_state == 0) {
                self.chatMiniMaxi(0);
            }
            return newDiv;
        }

    }

    this.chatCreateSecondaryContainer = function () {
        var container = document.getElementById("chat_secondary_container");

        if (container) {
            // если контейнер уже существует, то просто возвращаем ссылку на него
            return container;
        }

        container = document.createElement('div');
        container.id = 'chat_secondary_container';
        container.className = 'chat-mobile-secondary';
        container.innerHTML = `<div class="chat-mobile-secondary__bg js-toggle-chat_secondary_container"></div><div class="chat-mobile-secondary__list"></div><div class="chat-mobile-secondary__no-invitations-alert">${_l.no_inv_at_the_moment}</div>`;
        document.body.appendChild(container);

        var inv_node_buffer = document.createElement('div');
        inv_node_buffer.id = 'chat_inv_node_buffer';
        inv_node_buffer.style.display = 'none';
        document.body.appendChild(inv_node_buffer);

        $('.js-toggle-chat_secondary_container').on('click', function(e) {
            e.preventDefault();
            container.classList.toggle('chat-mobile-secondary--shown');
        });
        $('.h-js-toggle-chat_secondary_container-wrap').addClass('d-inline-block');
        return container;
    };

    var chatElementCounter = function () {
        return document.querySelectorAll('.chat-popup-container .notifier-wrap.notifier-wrap--fresh').length;
    };
    var updateChatSecondaryElementCounter = function () {
        let l = document.querySelectorAll('#chat_secondary_container .notifier-wrap').length;
        $('.js-toggle-chat_secondary_container_counter').text(l);
        if(l > 0) {
            $('.header-btn.js-toggle-chat_secondary_container').addClass('header-btn--has-new');
        } else {
            $('.header-btn.js-toggle-chat_secondary_container').removeClass('header-btn--has-new');
        }
    };
    var current_invitation = 0;

    var updateWidgetTitle = function () {
        var text;
        if (options.style === 'in_chat') {
            if (chatElementCounter() === 1) {
                text = _l.new_invites_1;
            } else {
                text = _l.new_invites.replace(/{count}/g, chatElementCounter());
            }

            document.getElementById("chat_main_container").querySelector('.chat-popup-container-title').textContent = text;
        }
    }
    var autoNavigateInvitations = true;
    var navigateInvitations = function (pos_diff) {
        if (chatElementCounter() == 0) {
            return;
        }
        var new_current_invitation = current_invitation + pos_diff, overflow;
        if (new_current_invitation < 0) {
            new_current_invitation = chatElementCounter() - 1;
            overflow = true;
        } else if (new_current_invitation >= chatElementCounter()) {
            new_current_invitation = 0;
            overflow = true;
        }
        if(current_invitation !== new_current_invitation) {
            current_invitation = new_current_invitation;
            $('#visual_elements .notifier-wrap').css({opacity: 0}).eq(current_invitation).css({opacity: 1});
        }
    }
    if (options.style == 'in_chat') {
        window.setInterval(function () {
            if (!autoNavigateInvitations || chatElementCounter() == 0) {
                return;
            }
            navigateInvitations(+1);
        }, 6000);
    }
    var pauseAutoNav = function () {
        autoNavigateInvitations = false;
        window.setTimeout(function () {
            autoNavigateInvitations = true;
        }, 10000);
    };

    var moveToSecondary = function (id, immediate) {
        if(typeof immediate === 'undefined') immediate = false;

        var container = self.chatCreateSecondaryContainer(), el = document.getElementById('e_'+id);
        if(container.contains(el)) {
            return;
        }
        var do_move = function () {
            container.querySelector('.chat-mobile-secondary__list').appendChild(el);
            el.classList.add('notifier-wrap--always-horizontal');
            el.style.height = 'auto';
            el.style.width = 'auto';
            el.classList.remove('--slide-up');
            messageScroll(document.getElementById('nmt_' + id), {speed: 150, delay: 1500, delayEnd: 1500});
            $(el)
                .find('a')
                .each(function () {
                    this.href = this.href.replace(/bh_medium=[a-z_]+/g, 'bh_medium=inv_cl'); // cloud
                });
            updateChatSecondaryElementCounter();
        };
        if(immediate) {
            do_move();
            return;
        }
        if(el) {
            if (0) {
                fadeOut(el);
            } else {
                slideUp(el);
            }
            window.setTimeout(do_move, 800);
        }
    };

    var getMaxChatElements = function () {
        if(horizontal_enabled) {
            if(window.matchMedia('(max-width: 1200px)').matches) {
                return 3;
            }
            if(window.matchMedia('(max-width: 960px)').matches) {
                return 2;
            }
        }
        return 4;
    };

    var handleExpiredInvitation = function (id) {
        var el = document.getElementById("e_" + id);
        var queue_element = getQueueElement(id);

        if(!!queue_element && ('user_id' in window) && window.user_id && el && [INV_TYPE_INV,INV_TYPE_BCAST].indexOf(queue_element.invitation) >= 0) {
            // Убрать из вторичной очереди
            if (queue_element.is_after_expired && queue_element.expires < ((new Date).getTime())) {
                chatHideElement(id, queue_element.i, queue_element.invitation, true);
                removeFromQueue(id);
                return;
            }

            if(!queue_element.is_after_expired) {
                queue_element.is_after_expired = true;
                queue_element.expires = (new Date).getTime() + after_expired_timeout_sec * 1000;
                queue_element.ttl = 180;

                if (INSTANCE_ID == STORAGE.host) {
                    reportCloseInvite(id, queue_element.i, queue_element.invitation, true, queue_element.track_id || 0);
                    STORAGE.last_event = {
                        type: 'set_after_expired',
                        id: id
                    };
                    saveStorage();
                }
                clearInterval(arCounters[id]);
                delete arCounters[id];
            }

            el.classList.remove('notifier-wrap--fresh');
            moveToSecondary(id);
            arAfterTimeouts[id] = window.setTimeout(function() {
                chatHideElement(id, queue_element.i, queue_element.invitation, true);
                removeFromQueue(id);
            }, queue_element.expires - (new Date).getTime());
        } else {
            if(!!queue_element) {
                chatHideElement(id, queue_element.i, queue_element.invitation);
                removeFromQueue(id);
            } else {
                chatHideElement(id);
            }
        }
    }

    var chatShowNewElement = function (data) {
        var bcastmess = "";
        var diff = "";
        var upd = data.upd;
        var lefttime = null;
        var name = data.name;
        // Приглашение прошло основной таймаут, но ещё висит во второй очереди
        var is_after_expired = data.is_after_expired || false;

        // Убираем инглиш нейм, чтобы больше было места под текст приглашения
        if (name && name.indexOf(' (') > -1) {
            name = name.substr(0, name.indexOf(' ('));
        }

        // ID нужен для того, чтобы определить не был ли уже показан этот элемент
        var id = data.id;

        var se = document.getElementById("e_" + id);
        var city = data.city;
        var camera = data.camera;
        var is_new_profile = data.is_new_profile;
        var age = data.age ? data.age : '-';
        var mess = data.mess ? data.mess : '';
        var image = data.image;
        var last_mess = data.last_mess;
        var iid = data.i;
        var bonus = data.bonus;
        var is_favorite = data.is_favorite > 0;
        var percentleft = 0;
        var isInv = data.invitation;
        let streaming_preview = data.streaming_preview || null;

        if (isInv == INV_TYPE_ONLINE && options.style == 'in_chat') {
            return;
        }
        if (isInv == INV_TYPE_STREAM && options.style == 'in_chat') {
            return;
        }

        if (isInv == INV_TYPE_BCAST) {
            bcastmess = data.full_mess;
        }

        lefttime = Math.ceil( (data.expires - (new Date).getTime()) / 1000 );
        if (lefttime < 0)
            lefttime = 0;

        if(lefttime == 0) {
            return;
        }

        percentleft = lefttime/data.ttl;
        percentleft = Math.floor(percentleft * 100);
        percentleft = 100 - percentleft;

        var cred = data.cred;

        jQuery('.js-total-credits').html(cred);

        window.credits = parseInt(cred);

        maxChatElements = getMaxChatElements();

        if (chatElementCounter() >= maxChatElements && upd != "1") {
            return;
        }

        // если количество уже отображаемых элементов не превышает максимального, то добавляем новый элемент, если превышает, то ничего не делаем
        if (name != "empty" && name != "" && (se === null || upd == "1") && (lefttime > 3 || lefttime === null)) {
            STORAGE.qid++;
            if(STORAGE.qid > 65000) {
                STORAGE.qid = 0;
            }
            var mainContainer = self.chatCreateMainContainer();

            mess = mess.replace(/\[([b|u|i])\]/g, "<$1>");
            mess = mess.replace(/\[a href=((http|\/|\.)[^\]]+)\]/g, '<a href="$1">');
            mess = mess.replace(/\[\/([b|u|i|a])\]/g, "</$1>");

            if (/^GAME_/.test(mess)) {
                var gameCommand = mess.split('#');
                switch (gameCommand[0]) {
                    case 'GAME_JOIN':
                        var game = arChatGames[gameCommand[1]];
                        mess = _l.game_invite({name: name, game: game});
                        break;
                    default :
                        mess = '';
                        break;
                }
            }

            if(!is_after_expired) {
                document.getElementById("chat_main_container").style.display = "block";
                fadeIn(document.getElementById('chat_main_container'));
            }
            // создаем HTML-код нового элемента
            if (isInv == INV_TYPE_INV || isInv == INV_TYPE_BCAST) {
                mess = '<div class="notifier-message"><div class="notifier-message-text" id="nmt_' + id + '"><div class="notifier-message-text-content">' + mess + '</div></div></div>';
            } else if (isInv == INV_TYPE_VIEW) {
                mess = `<div class="notifier-caption-watching">` + _l.viewer_message({name: escapeHtml(name), age: age}) + `</div>`;
            } else {
                mess = `<div class="notifier-caption-watching notifier-caption-watching--online">` + _l.is_online_message({name: escapeHtml(name), age: age}) + `</div>`;
            }

            var newElement = '';
            var notifier_item_style = '';

            if(animations_enabled) {
                if(horizontal_enabled) {
                    notifier_item_style = 'width: 0px; transition: height 0.7s ease-out, width 0.7s ease-out, opacity 0.7s ease-out;';
                } else {
                    notifier_item_style = 'height: 0px; transition: height 0.7s ease-out, width 0.7s ease-out, opacity 0.7s ease-out;';
                }
            } else {
                notifier_item_style = 'height: 0px;';
            }

            if(options.style == 'in_chat') {
                notifier_item_style = 'opacity: 0; transition: opacity 0.7s ease-out;';
            }

            newElement += '<div class="notifier-wrap notifier-wrap--fresh '+(is_favorite ? ' notifier-wrap--favorite' : '')+'" data-person-id="' + id + '" id="e_' + id + '" style="'+notifier_item_style+'">';

            let notifier_class = 'notifier';
            if(is_favorite) notifier_class += ' notifier--favorite';
            notifier_class += ` notifier--${isInv}`;
            if(streaming_preview) notifier_class += ' notifier--stream-has-preview';

            newElement += '<div class="' + notifier_class + '" data-person-id="' + id + '">';

            newElement += '<div class="notifier-content-wrap">';

            newElement += `<span class="notifier-close-action" title="${_l.close}"></span>`;

            var p_link = profile_link(id);

            if(isInv == INV_TYPE_STREAM) {
                p_link = streaming_link(id);
            }

            let simple_notification_content = '<div class="notifier-photo-container"><a href="' + p_link + '"><img class="notifier-photo" alt="" src="' + image + '" height="133" width="100" />' + (camera == '1' ? '<span class=\'notifier-webcam\'></span>' : '') + '</a></div>';

            simple_notification_content += '<div class="notifier-info-container">';

            simple_notification_content += '<div class="notifier-info"><div class="notifier-name"><a class="notifier-name__link" href="' + p_link + '">' + name + '</a> <span class="notifier__age">' + age + '</span></div></div>';

            simple_notification_content +=  mess;

            var button_class = bonus == 'yes' ? "notifier-start-chat notifier-bonus" : "notifier-start-chat";
            var button_text = bonus == 'yes' ? arChatButtonNames.bonus : arChatButtonNames.normal;

            if(isInv == INV_TYPE_STREAM) {
                button_class = "notifier-start-chat notifier-start-chat--stream";
                button_text = arChatButtonNames.stream;
            }

            if(button_text === arChatButtonNames.normal && camera == 1) {
                button_text = arChatButtonNames.video;
            }

            simple_notification_content += '<div class="' + button_class + '">';
            simple_notification_content += '<input type="hidden" value="open" name="s_' + id + '" id="s_' + id + '" />';
            simple_notification_content += '<button class="notifier-startchat-button">' + button_text + '</button>';
            simple_notification_content += '</div>';

            simple_notification_content += '</div>';

            if(isInv == INV_TYPE_STREAM && streaming_preview) {
                newElement += `<input type="hidden" value="open" name="s_${id}" id="s_${id}" />
<div class="notifier-top notifier-top--streaming-preview notifier-top--full-only">
    <video class="notifier-streaming-video" src="${streaming_preview.path}" width="${streaming_preview.w}" height="${streaming_preview.h}" muted loop autoplay playsinline></video>    
    <video class="notifier-streaming-video notifier-streaming-video--bg"
           preload="none" src="${streaming_preview.path}" width="${streaming_preview.w}" height="${streaming_preview.h}" muted loop
           playsinline></video>
    <div class="notifier-info-container">
        <div class="notifier-info">
            <div class="notifier-name" href="${p_link}" target="_blank">${name} <span class="notifier__age">${age}</span>
            </div>
        </div>
        <div class="notifier-start-chat notifier-start-chat--stream">
            <button class="notifier-startchat-button">${arChatButtonNames.stream}</button>
        </div>
    </div>
</div>
<div class="notifier-top notifier-top--compact-only">${simple_notification_content}</div>`;
            } else {
                newElement += `<div class="notifier-top">${simple_notification_content}</div>`;
            }

            newElement += '</div>';
            newElement += '</div>';

            if (options.style === 'in_chat') {
                newElement += '<div class="notifiers-navigation"><button class="notifications-button-back"><img src="https://static.behappy2day.com/chat/m/img/left.svg" width="24" height="24"></button> <button class="notifications-button-forward"><img src="https://static.behappy2day.com/chat/m/img/left.svg" width="24" height="24" style="transform: scaleX(-1)"></button></div>';
            }

            newElement += '</div>';

            newElement = $(newElement);

            newElement.on('click', function () {
                if('BH_AT' in window) {
                    window.BH_AT.ta('invite_click', isInv, {});
                }
            })

            if (isInv === INV_TYPE_ONLINE || isInv === INV_TYPE_STREAM) {
                newElement.on('click', function () {
                    if(horizontal_enabled) {
                        document.location.href = p_link;
                    }
                })
            }

            newElement.find('.notifier-startchat-button, .notifier-message-text, .notifier-top--streaming-preview .notifier-info-container').on('click', function (e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                if (options.logged_in || isInv == INV_TYPE_STREAM) {
                    var qe = getQueueElement(id);
                    var invite_type = qe.is_after_expired ? self.CHAT_START_INV_AFTER_EXPIRED : getCurrentInvType();
                    if (isInv == INV_TYPE_INV) {
                        self.wchatopen(id, iid, {last_mess: last_mess});
                        self.trackChatStart(id, invite_type, {invite_kind: 'personal'});
                    } else if (isInv == INV_TYPE_BCAST) {
                        self.winchatopen(id, 1, iid, {is_bc: 1});
                        self.trackChatStart(id, invite_type, {invite_kind: 'broadcast'});
                    } else if (isInv == INV_TYPE_STREAM) {
                        document.location.href = streaming_link(id);
                    } else {
                        self.winchatopen(id);
                        if('BH_AT' in window) {
                            window.BH_AT.ta('invite_click', isInv, {});
                        }
                        self.trackChatStart(id, invite_type, {invite_kind: 'other'});
                    }
                } else {
                    self.gotologin(id);
                }
            });

            newElement.find('.notifier-close-action').on('click', function (e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                chatHideElement(id, iid, isInv == INV_TYPE_BCAST ? 1 : 0, undefined, true);
                removeFromQueue(id);
            });

            newElement.find('.notifications-button-forward').on('click', function (e) {
                e.stopImmediatePropagation();
                navigateInvitations(+1);
                pauseAutoNav();
            });
            newElement.find('.notifications-button-back').on('click', function (e) {
                e.stopImmediatePropagation();
                navigateInvitations(-1);
                pauseAutoNav();
            });
            let video = newElement[0].querySelector('.notifier-streaming-video:not(.notifier-streaming-video--bg)');
            let video_bg = newElement[0].querySelector('.notifier-streaming-video--bg');
            if(video && video_bg) {
                makeVideosSynced(video, video_bg);
            }

            if (se !== null && upd == "1") {
                $("#e_" + id).replaceWith(newElement);
                newElement[0].style.height = newElement[0].scrollHeight + 'px';
                messageScroll(document.getElementById('nmt_' + id), {speed: 150, delay: 1500, delayEnd: 1500});
            } else {
                var container = $("#visual_elements");
                if(mobile_enabled && container.children().length > 0) {
                    container.children().each(function() {
                        let id = this.getAttribute('data-person-id');
                        if(window.clc === 1) {
                            moveToSecondary(id, !queue_loaded);
                        } else {
                            chatHideElement(id);
                            removeFromQueue(id);
                        }
                    });
                }

                if(!is_after_expired) {
                    container.append(newElement);
                } else {
                    self.chatCreateSecondaryContainer();
                    $('#chat_inv_node_buffer').append(newElement);
                    handleExpiredInvitation(id);
                }

                if (options.style == 'in_chat') {
                    if(chatElementCounter() === 1) {
                        fadeIn(document.getElementById("e_" + id));
                    }
                    messageScroll(document.getElementById('nmt_' + id), {speed: 150, delay: 1500, delayEnd: 1500});
                } else {
                    slideDown(document.getElementById("e_" + id), function () {
                        messageScroll(document.getElementById('nmt_' + id), {speed: 150, delay: 1500, delayEnd: 1500});
                    });
                }

                // увеличиваем счетчик отображаемых элементов
                updateWidgetTitle();
            }

            if (isInv == INV_TYPE_ONLINE) {
                evalCloseTimer(666, id, iid);
            } else {
                if(document.visibilityState === 'hidden') {
                    var strMesNew = _l.new_inv_title_blink;

                    if ((timBlinkTimer === null)) {
                        timBlinkTimer = setInterval(function () {
                                document.title = document.title == strMesNew ? _l.new_inv_title_blink1 : strMesNew;
                            }, 1000
                        ); // реализуем "мигание тайтлом"

                        mousemove_handler = function () {
                            clearInterval(timBlinkTimer);
                            timBlinkTimer = null;
                            document.title = strOldTitle;
                            document.onmousemove = null;
                        }

                        document.addEventListener('mousemove', mousemove_handler, {once: true});
                        document.addEventListener('touchstart', mousemove_handler, {once: true});
                    }
                }

                if (is_favorite && STORAGE.host == INSTANCE_ID) {
                    var notification_text = $("#e_" + id).find('.notifier-message-text-content').text();
                    if ('notifications_module' in window) {
                        notifications_module.notify({
                            type: 'invite-notification',
                            tag: 'invite_' + id,
                            title: name + ' ID ' + id,
                            body: notification_text,
                            icon: image,
                            vibrate: [100, 100, 300],
                            requireInteraction: true
                        });
                    }
                }

                if(!is_after_expired) {
                    if (isInv == INV_TYPE_BCAST) {
                        evalCloseTimer(666, id, iid, 1);
                    } else if (isInv == INV_TYPE_VIEW) {
                        evalCloseTimer(150, id, iid, 1);
                    } else
                        evalCloseTimer(2000, id, iid);
                }
            }

        } else {
            if (document.getElementById("total_credits")) {
                var cred = data.cred;
                document.getElementById("total_credits").innerHTML = cred;
            }
        }

    };

    this.chatMiniMaxi = function (state) {
        var new_state = (stateOfNotifiers == 1 ? 0 : 1);
        if (typeof state !== 'undefined' && state == new_state) {
            return;
        }

        var mainContainer = document.getElementById("chat_main_container");

        var rBlock = document.getElementById("r_block");

        if (stateOfNotifiers == 1) {
            mainContainer.classList.add('chat-popup-container--minimized');
        } else {
            mainContainer.classList.remove('chat-popup-container--minimized');
        }
        stateOfNotifiers = new_state;
        STORAGE.collapse_state = stateOfNotifiers;
        saveStorage();

        if(!horizontal_enabled && !mobile_enabled) {
            slideToggle(document.getElementById('visual_elements_wrapper'));
        }
    }

    var chatHideElement = function (elementID, i, isBc, is_timed_out, force_callback) {
        isBc = typeof (isBc) != 'undefined' ? isBc : 0;
        is_timed_out = typeof (is_timed_out) != 'undefined' ? is_timed_out : false;
        force_callback = typeof (force_callback) != 'undefined' ? force_callback : false;

        i = typeof (i) != 'undefined' ? i : 0;    //ID приглашения
        if (options.style == 'in_chat') {
            fadeOut(document.getElementById("e_" + elementID));
        } else {
            slideUp(document.getElementById("e_" + elementID));
        }
        let queue_element = getQueueElement(elementID);

        // определяем статус блока (закрыт или открыт)
        var status = document.getElementById("s_" + elementID);
        if (status && status.value == "open") {
            status.value = "closed";
            // остановка таймера
            if(arCounters[elementID]) {
                clearInterval(arCounters[elementID]);
                delete arCounters[elementID];
            }
            if(arAfterTimeouts[elementID]) {
                clearTimeout(arAfterTimeouts[elementID]);
                delete arAfterTimeouts[elementID];
            }
            document.getElementById("e_" + elementID).classList.remove('notifier-wrap--fresh');

            setTimeout(function () {
                var tmp = document.getElementById("e_" + elementID);
                var tmp_parent = tmp.parentNode;
                removeElement(tmp);
                if(tmp_parent.classList.contains('notifier-wrap')) {
                    removeElement(tmp_parent);
                }
                updateChatSecondaryElementCounter();
            }, 700);
            if (current_invitation > chatElementCounter() - 1 && chatElementCounter() > 0) {
                navigateInvitations(-1);
            }
        }
        if (chatElementCounter() < 1) {
            fadeOut(document.getElementById("chat_main_container"));
            clearInterval(timBlinkTimer);
            timBlinkTimer = null;
            document.title = strOldTitle;
        } else {
            updateWidgetTitle();
        }
        if ((STORAGE.host == INSTANCE_ID || force_callback) && options.logged_in && i != 0 && queue_element) {
            reportCloseInvite(elementID, i, isBc, is_timed_out, queue_element.track_id || 0);
        }
    }

    var reportCloseInvite = function(elementID, i, isBc, is_timed_out, track_id) {
        $.ajax({
            url: options.scripts_root + "end_invite.php?i=" + (i || '0') + "&x=" + (is_timed_out ? 2 : 1) + "&gid=" + elementID + (isBc ? "&bcast=1" : '') + (track_id ? "&track_id=" + track_id : ''),
            type: 'get'
        });
    };

    var reportOpenInvite = function(elementID, i, isBc, track_id) {
        $.ajax({
            url: options.scripts_root + "end_invite.php?i=" + (i || '0') + "&gid=" + elementID + (isBc ? "&bcast=1" : '') + (track_id ? "&track_id=" + track_id : ''),
            type: 'get'
        });
    };

    var evalCloseTimer = function (timeout, elementID, id, isBc) {
        isBc = typeof (isBc) != 'undefined' ? isBc : 0;
        var queue_element = getQueueElement(elementID);
        if(!queue_element) {
            clearInterval(arCounters[elementID]);
            delete arCounters[elementID];
            return;
        }

        try {
            if (typeof (arCounters[elementID]) !== "undefined") {
                clearInterval(arCounters[elementID]);
                delete arCounters[elementID];
            }
            arCounters[elementID] = setInterval(function () {
                var wrapper = self.chatCreateMainContainer();
                var wrapper2 = self.chatCreateSecondaryContainer();

                var i = Math.ceil((queue_element.expires - (new Date).getTime()) / 1000 / queue_element.ttl * 100);
                if (i <= 100 && i > 0) {

                } else if(!wrapper.matches(':hover') && (!wrapper2 || !wrapper2.matches(':hover'))) {
                    handleExpiredInvitation(elementID);
                }

                }, timeout
            );
        } catch (e) {
        }
    }
    // открытие окна чата
    this.wchatopen = function (id, iid, params) {
        gotochatwindow(params, id);

        let queue_element = getQueueElement(id);

        if(queue_element) {
            chatHideElement(id);
            removeFromQueue(id);
            reportOpenInvite(id, iid, false, queue_element.track_id || 0);
        }
    }

    var gotochatwindow = function (params, id) {
        if (options.custom_open_chat_action) {
            options.custom_open_chat_action(id, params);
            return;
        }

        var chatWindowID = 'bh_chatWin', tabs_enabled = true, start_timer;
        var chatWindowOptions = 'top=15,left=20,menubar=0,toolbar=0,location=1,directories=0,status=0,scrollbars=1,resizable=1,width=' + Math.min(1920, window.outerWidth - 50).toString() + ',height=' + Math.min(980, window.outerHeight - 50).toString();
        var w;

        if(window.PAGE_ID === 'STREAMING') {
            w = Math.ceil(window.screen.availWidth*0.3);
            if(laptop_enabled) {
                chatWindowOptions = 'top=0,left=' + (window.screen.availWidth - w - 5).toString() + ',menubar=0,toolbar=0,location=1,directories=0,status=0,scrollbars=1,resizable=1,width=' + w.toString() + ',height=' + window.screen.availHeight.toString();
            } else {
                chatWindowOptions = 'top=0,left=0,menubar=0,toolbar=0,location=1,directories=0,status=0,scrollbars=1,resizable=1,width=' + w.toString() + ',height=' + window.screen.availHeight.toString();
            }
        }

        var url = '/chat.php';

        var chatWin = {};

        if (
            (
                !navigator.userAgent.match(/Windows NT|Macintosh/) &&
                !(navigator.userAgent.match(/Chrome/) && navigator.userAgent.match(/Android/))
            ) ||
            (navigator.userAgent.match(/MSIE [0-9]\./)) ||
            (navigator.userAgent.match(/(iPad|iPhone); CPU (iPad|iPhone)? OS 12/))
        ) {
            chatWindowID += id;
            tabs_enabled = false;
            url = '/chat/index.php?gID=' + id;
            if (params) {
                for (var k in params) {
                    url += '&' + k + '=' + encodeURIComponent(params[k]);
                }
                ;
            }
        }

        try {
            if (navigator.userAgent.match(/Vivaldi\/(0\.|1\.0)/)) {
                chatWin = window.open(url, chatWindowID, chatWindowOptions);
                return;
            } else if (navigator.userAgent.match(/(iPad|iPhone); CPU (iPad|iPhone)? OS 12/)) {
                chatWin = window.open(url, chatWindowID, chatWindowOptions);
                return;
            } else if (navigator.userAgent.match(/Opera/) && window.opera) {
                chatWin = window.open("file:///D:/1.swfz", chatWindowID, chatWindowOptions);
            } else {
                chatWin = window.open("", chatWindowID, chatWindowOptions);
            }

            if (!chatWin.location.href.match(/\/chat/)) {
                chatWin.location.href = url;
                chatWin.focus();
            } else {
                chatWin.focus();
            }

        } catch (e) {
            chatWin = window.open(url, chatWindowID, chatWindowOptions);
        }

        if (tabs_enabled) {
            if (chatWin.chat_created) {
                chatWin.LiveChat.startChatById(id, params);
            } else {
                start_timer = window.setInterval(function () {
                    if (chatWin.chat_created) {
                        window.clearInterval(start_timer);
                        chatWin.LiveChat.startChatById(id, params);
                    }
                }, 500);
            }
        }

    }

    this.winchatopen = function (id, isBc, iid, params) {
        isBc = typeof (isBc) != 'undefined' ? isBc : 0;

        if (typeof params == 'object') {
            params.isBc = isBc;
        } else {
            params = {isBc: isBc};
        }

        gotochatwindow(params, id);
        let queue_element = getQueueElement(id);

        try {
            chatHideElement(id);
            removeFromQueue(id);
            // определяем статус блока (закрыт или открыт)
            var status = document.getElementById("s_" + id);

            if (status !== null && status.value == "open") {
                status.value = "closed";

                updateWidgetTitle();

                setTimeout(function () {
                    removeElement(document.getElementById("e_" + id));
                    updateChatSecondaryElementCounter();
                }, 700);
            }

            if (chatElementCounter() < 1) {
                fadeOut(document.getElementById('chat_main_container'));
                clearInterval(timBlinkTimer);
                timBlinkTimer = null;
                document.title = strOldTitle;
            }
            reportOpenInvite(id, iid, isBc, (queue_element.track_id || 0));
        } catch (e) {

        }
    }

    this.gotologin = function (id) {
        document.location.href = options.login_link_template.replace(/%id%/g, (id )).replace(/%redirect%/g, encodeURIComponent(profile_link(id)));
    }

    var loadInitialQueue = function () {
        var now = (new Date).getTime();
        STORAGE.queue = STORAGE.queue.filter(function(v) {
            return v.expires > now + 3000;
        });
        var q = STORAGE.queue;
        q.forEach(function (v) {
            if(v.clc != options.logged_in) {
                removeFromQueue(v.id);
            }
        });
        q.forEach(chatShowNewElement);
        saveStorage();
    };

    var addToQueue = function(data) {
        data.clc = options.logged_in;

        var index = null;
        STORAGE.queue.forEach(function(v,k) {
            if(v.id == data.id) {
                index = k;
            }
        });
        if(index !== null) {
            STORAGE.queue.splice(index, 1);
        }
        STORAGE.queue.push(data);
        STORAGE.last_event = {
            type: 'add',
            id: data.id
        };
        saveStorage();
    };

    var removeFromQueue = function(id) {

        var index = null;
        STORAGE.queue.forEach(function(v,k) {
            if(v.id == id) {
                index = k;
            }
        });
        if(index !== null) {
            STORAGE.last_event = {
                type: 'remove',
                id: id
            };
            STORAGE.queue.splice(index, 1);
            saveStorage();
        }

    };

    var getQueueElement = function(id) {
        var index = null;
        STORAGE.queue.forEach(function(v,k) {
            if(v.id == id) {
                index = k;
            }
        });
        if(index !== null) {
            return STORAGE.queue[index];
        } else {
            return null;
        }
    }

    var initStorageEvents = function() {
        window.addEventListener('storage', function(event) {
            if(event.key != STORAGE_KEY) {
                return;
            }
            var old = JSON.parse(event.oldValue);
            loadStorage();
            if(!!old && !!STORAGE)
            if('last_event' in STORAGE && 'last_event' in old && old.last_event != STORAGE.last_event) {
                switch (STORAGE.last_event.type) {
                    case 'add':
                        STORAGE.queue.forEach(function(v) {
                            if(v.id == STORAGE.last_event.id) {
                                chatShowNewElement(v);
                            }
                        });
                        break;
                    case 'remove':
                        old.queue.forEach(function(v) {
                            if(v.id == STORAGE.last_event.id) {
                                chatHideElement(v.id, v.i, v.invitation == INV_TYPE_BCAST);
                            }
                        });
                        break;
                    case 'set_after_expired':
                        old.queue.forEach(function(v) {
                            if(v.id == STORAGE.last_event.id) {
                                handleExpiredInvitation(v.id);
                            }
                        });
                        break;
                    case 'credits':
                        if (document.getElementById("total_credits")) {
                            document.getElementById("total_credits").innerHTML = STORAGE.last_event.amt;
                        }
                        window.credits = parseInt(STORAGE.last_event.amt);
                        break;
                }
            }
        });
    };

    this.startPolling = function () {
        $(document).on('click', function (event) {
            if( !$("#chat_secondary_container").has(event.target).length && !$(".js-toggle-chat_secondary_container").has(event.target).length && !$(event.target).is(".js-toggle-chat_secondary_container") ) {
                $('#chat_secondary_container').removeClass('chat-mobile-secondary--shown');
            }
        });

        initStorage();
        loadInitialQueue();
        queue_loaded = true;
        initStorageEvents();

        var invite_callback = function (data) {
            STORAGE.last_updated = (new Date).getTime();
            saveStorage();

            if(data.id !== null) {
                if('expires_in_sec' in data) {
                    data.expires = (new Date).getTime() + data.expires_in_sec * 1000;
                } else {
                    data.expires = (new Date).getTime() + 60 * 1000;
                    data.ttl = 60;
                }
                addToQueue(data);
            } else {
                STORAGE.last_event = {
                    type: 'credits',
                    amt: data.cred
                }
            }
            chatShowNewElement(data);
        };

        var polling_function = function () {
            var shown = '0';
            $('#chat_main_container .notifier:not(.notifier--viewer)')
                .each(function () {
                    shown += '|' + this.getAttribute('data-person-id');
                });

            var maxChatElements = getMaxChatElements();

            if(options.demo) {
                if(Array.isArray(options.demo_invitations) && options.demo_invitations.length > 0) {
                    var next = options.demo_invitations.pop();
                    invite_callback(next);
                    options.demo_invitations.unshift(next);
                }
            } else {
                $.ajax({
                    type: "get",
                    url: options.scripts_root + 'invite.v4.php',
                    data: {
                        free_slots: maxChatElements - chatElementCounter(),
                        active: shown,
                        qid: STORAGE.qid
                    },
                    success: invite_callback
                });
            }
        };

        var scheduled_task = function () {
            if(STORAGE.host != INSTANCE_ID && STORAGE.last_updated < (new Date).getTime() - options.polling_interval * 2) {
                becomeHost();
            }

            if(STORAGE.host == INSTANCE_ID) {
                polling_function();
            }
        };

        scheduled_task();
        window.setInterval(scheduled_task, options.polling_interval);
    }

    var SpecialOfferTimer = function () {
        var starts_ts = 1707886800;
        var ends_ts = 1707973199;
        var get_ts = function () {
            return (Date.now ? Date.now() : (new Date).getTime()) / 1000;
        };
        var handler = function () {
            var now = get_ts();
            if ((now >= starts_ts && now <= ends_ts) || document.location.search.match(/off01=1/) || window.chat_marathon_active) {
                if (options.style !== 'in_chat') {
                    $('#chat_main_container').addClass('chat-popup-container--offer');
                    $('#chat_main_container').find('.chat-popup-container-title').html('<span>Join our Chat Marathon!</span>');
                }
                window.clearInterval(interval);
            }
        };
        var interval = window.setInterval(handler, 10000);
        handler();
    }

    this.CHAT_START_PROFILE = 0;
    this.CHAT_START_INV_VERTICAL = 1;
    this.CHAT_START_INV_HORIZONTAL = 2;
    this.CHAT_START_INV_MOBILE = 3;
    this.CHAT_START_LIST = 4;
    this.CHAT_START_MAIL = 5;
    this.CHAT_START_INV_AFTER_EXPIRED = 6;
    this.CHAT_START_BELL_NOTIFICATIONS = 7;
    this.CHAT_START_LEFT_VERTICAL = 8;
    this.CHAT_START_STREAMING = 9;
    this.CHAT_START_PUSH = 10;

    this.INVITE_CLICK_P = 1;
    this.INVITE_CLICK_B = 2;
    this.INVITE_CLICK_O = 3;

    var getCurrentInvType = function() {
        if(mobile_enabled) {
            return self.CHAT_START_INV_MOBILE;
        }
        if(laptop_enabled) {
            return self.CHAT_START_LEFT_VERTICAL;
        }
        if(horizontal_enabled) {
            return self.CHAT_START_INV_HORIZONTAL;
        }
        return self.CHAT_START_INV_VERTICAL;
    }

    this.trackChatStart = function (chatmate_id, type, extra) {
        let d = new URLSearchParams({
            action: 'track_chat_start',
            chatmate_id: chatmate_id,
            type: type,
            theme: window.theme || ''
        });
        let payload = extra && typeof extra === 'object' ? Object.assign({}, extra) : {};
        let q = new URLSearchParams(document.location.search);
        if(type === self.CHAT_START_PROFILE) {
            if( q.get('bh_medium') ) {
                payload.from = q.get('bh_medium');
            }
        }
        if(Object.keys(payload).length) {
            d.append('extra', JSON.stringify(payload));
        }
        navigator.sendBeacon('/ajax.php', d);

        if('BH_AT' in window) {
            window.BH_AT.ta('chat_start', type, { chatmate: chatmate_id });
        }
    }
    /**
     *
     * @param {HTMLMediaElement} primary_video
     * @param {HTMLMediaElement}  secondary_video
     */
    let makeVideosSynced = function (primary_video, secondary_video) {
        primary_video.addEventListener('playing', function() { secondary_video.play(); secondary_video.currentTime = primary_video.currentTime });
        primary_video.addEventListener('playing', function() { secondary_video.currentTime = primary_video.currentTime });
    }
}